import React from "react";
import { cn } from "@/lib/utils";
import { useTranslation } from '../hooks/useTranslation';
import {
  IconAdjustmentsBolt,
  IconCloud,
  IconCurrencyDollar,
  IconEaseInOut,
  IconHeart,
  IconHelp,
  IconRouteAltLeft,
  IconTerminal2,
  IconShieldCheck,
  IconRocket,
  IconInfinity,
} from "@tabler/icons-react";

export function FeaturesSectionWithHoverEffects() {
  const { t } = useTranslation();
  
  const features = [
    {
      title: t('feature1Title'),
      description: t('feature1Desc'),
      icon: <IconShieldCheck />,
    },
    {
      title: t('feature2Title'),
      description: t('feature2Desc'),
      icon: <IconEaseInOut />,
    },
    {
      title: t('feature3Title'),
      description: t('feature3Desc'),
      icon: <IconCurrencyDollar />,
    },
    {
      title: t('feature4Title'),
      description: t('feature4Desc'),
      icon: <IconCloud />,
    },
    {
      title: t('feature5Title'),
      description: t('feature5Desc'),
      icon: <IconRouteAltLeft />,
    },
    {
      title: t('feature6Title'),
      description: t('feature6Desc'),
      icon: <IconHelp />,
    },
    {
      title: t('feature7Title'),
      description: t('feature7Desc'),
      icon: <IconAdjustmentsBolt />,
    },
    {
      title: t('feature8Title'),
      description: t('feature8Desc'),
      icon: <IconInfinity />,
    },
  ];
  
  return (
    <div className="py-20 px-4">
      <div className="max-w-7xl mx-auto mb-12 text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
          {t('featuresTitle')}
        </h2>
        <p className="text-lg text-slate-400 max-w-2xl mx-auto">
          {t('featuresSubtitle')}
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 relative z-10 max-w-7xl mx-auto py-6">
        {features.map((feature, index) => (
          <Feature key={feature.title} {...feature} index={index} />
        ))}
      </div>
    </div>
  );
}

const Feature = ({ title, description, icon, index }) => {
  return (
    <div
      className={cn(
        "flex flex-col lg:border-r py-10 relative group/feature border-slate-800",
        (index === 0 || index === 4) && "lg:border-l border-slate-800",
        index < 4 && "lg:border-b border-slate-800"
      )}
    >
      {index < 4 && (
        <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-slate-800 to-transparent pointer-events-none" />
      )}
      {index >= 4 && (
        <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-slate-800 to-transparent pointer-events-none" />
      )}
      <div className="mb-4 relative z-10 px-10 text-slate-400">
        {icon}
      </div>
      <div className="text-lg font-bold mb-2 relative z-10 px-10">
        <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-slate-700 group-hover/feature:bg-emerald-500 transition-all duration-200 origin-center" />
        <span className="group-hover/feature:translate-x-2 transition duration-200 inline-block text-white">
          {title}
        </span>
      </div>
      <p className="text-sm text-slate-300 max-w-xs relative z-10 px-10">
        {description}
      </p>
    </div>
  );
};
